import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const formControlStyle: SxProps<Theme> = {
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '14px',

	// clear margin
	ml: 0,

	// fix paddings
	'& .MuiCheckbox-root': {
		padding: '9px',
		margin: '-9px 0px -9px -9px',
	},

	'& .MuiTypography-root': {
		color: Colors.fontColor,
		fontFamily: 'inherit',
		fontSize: 'inherit',
		lineHeight: 'inherit',
	},

	'&.Mui-error .MuiTypography-root': {
		color: Colors.redDark,
	},

	'&.Mui-disabled .MuiTypography-root': {
		color: Colors.grayDark,
	},
};
